/**
 * Discarded before: the work a person threw away on this ticket with Start
 * over, newest first, and why. Reeve's plan and Wright's build read the same
 * list. Each entry opens the attempt it describes. The ticket read carries the
 * list (`discardsBehind`); it shows nothing when there is none.
 */
import type { WorkItemDiscardDto } from "@yagni/shared";

import { Fold } from "../queue/index.js";
import {
  DISCARDED_BEFORE_READ_BY,
  DISCARDED_BEFORE_TITLE,
  DISCARDED_NO_REASON,
  discardedFacts,
} from "../work/workCopy.js";
import "./startOver.css";

function day(iso: string): string {
  const date = new Date(iso);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function DiscardedBefore({
  discards,
  onOpen,
}: {
  discards: readonly WorkItemDiscardDto[];
  onOpen: (workItemId: string) => void;
}) {
  if (discards.length === 0) return null;
  return (
    <Fold title={DISCARDED_BEFORE_TITLE} count={String(discards.length)} defaultOpen>
      <div className="discards" data-testid="discarded-before">
        {discards.map((discard) => (
          <button
            key={discard.id}
            type="button"
            className="discard"
            onClick={() => onOpen(discard.workItemId)}
          >
            <span className="dh">
              <b>
                {day(discard.discardedAt)}
                {discard.discardedBy ? ` · ${discard.discardedBy}` : ""}
              </b>
              <span>· {discardedFacts(discard)}</span>
            </span>
            {discard.reason?.trim() ? (
              <span className="why">“{discard.reason.trim()}”</span>
            ) : (
              <span className="why none">{DISCARDED_NO_REASON}</span>
            )}
          </button>
        ))}
        <p className="fact" style={{ fontSize: 11.5 }}>
          {DISCARDED_BEFORE_READ_BY}
        </p>
      </div>
    </Fold>
  );
}
